import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.SectionLineItemSettings', {
    title: 'Line items',
    subtitle: 'Available tables in the request:',
    optionAll: 'Both Category and Item details tables',
    optionAccountBasedLines: 'Category details table',
    optionItemBasedLines: 'Item details table',
});
